// extracted by mini-css-extract-plugin
export default {"container":"Uba-z","creativeContainer":"Vba-z","copy":"Wba-z","cta":"Xba-z","disabled":"Yba-z","flipped":"Zba-z","productCard":"_ba-z"};